import { Layout } from "antd";
import React, { useState } from "react";
import myImage from "../../../assets/icons/ustlogo1.png";
import myProfile from "../../../assets/icons/profile.jpg";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;
const LogBookNavbar = () => {

  const[isDropdownVisible,setIsDropdownVisible]=useState(false)
  const navigate=useNavigate();
  
  const handleLogout = () => {
    localStorage.clear();
    navigate('/logbook/login');
    setIsDropdownVisible(false);
  };
  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle the dropdown visibility
  };
  return (
    <div>
      <Header className="flex justify-between items-center bg-primary text-white h-[70px] px-[20px] md:px-[50px] font-poppins font-bold">
        <div className="flex items-center">
          <img src={myImage} className="h-[40px] md:h-[70px] mr-4" alt="Logo" />
        </div>

        <div className="text-center text-lg md:text-2xl">LOG BOOK</div>

        <button
          className="w-[50px] h-[50px] rounded-full border-2 border-gray-300 overflow-hidden"
          onClick={toggleDropdown}
        >
          <img
            src={myProfile}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        </button>
        {isDropdownVisible && (
            <div className="absolute right-0 top-[60px] bg-white border border-gray-300 shadow-md rounded-md p-4 w-[180px]">
              <button
                className="text-sm text-black hover:text-blue-700 mt-2 w-full text-left"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
      </Header>
    </div>
  );
};

export default LogBookNavbar;
